import { render } from "./SeedsView.vue?vue&type=template&id=186883cd&scoped=true"
import script from "./SeedsView.vue?vue&type=script&lang=js"
export * from "./SeedsView.vue?vue&type=script&lang=js"

import "./SeedsView.vue?vue&type=style&index=0&id=186883cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186883cd"]])

export default __exports__